/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%]{border-bottom:0!important;padding-bottom:0;padding-left:0;padding-right:0;box-shadow:none;font-size:12px;color:#8e8fa6;background-color:#fff}.item[_ngcontent-%COMP%]{width:10%;display:flex;vertical-align:middle;align-items:center;padding-left:20px}.item[_ngcontent-%COMP%]:first-of-type{width:70%}.wrapper[_ngcontent-%COMP%]{display:flex}"];
export { styles as styles };
